import { render, staticRenderFns } from "./CriticismTable.vue?vue&type=template&id=4d8eb53d"
import script from "./CriticismTable.vue?vue&type=script&lang=js"
export * from "./CriticismTable.vue?vue&type=script&lang=js"
import style0 from "./CriticismTable.vue?vue&type=style&index=0&id=4d8eb53d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports